import { render, staticRenderFns } from "./WorkflowDesignerPage.vue?vue&type=template&id=4fc39b28&scoped=true&"
import script from "./WorkflowDesignerPage.vue?vue&type=script&lang=js&"
export * from "./WorkflowDesignerPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowDesignerPage.vue?vue&type=style&index=0&id=4fc39b28&scoped=true&lang=css&"
import style1 from "./WorkflowDesignerPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc39b28",
  null
  
)

export default component.exports